import React, { useState } from 'react';
import { BringzzText, BringzzIcon } from "@bringzz/components";
import useUser from 'hooks/useUser';

const getRelativeTime = (dateString) => {
    if (!dateString) return '';
    
    let date;
    if (typeof dateString === 'number') {
        date = dateString > 10000000000 ? new Date(dateString) : new Date(dateString * 1000);
    } else if (dateString.includes('.')) {
        // Parse DD.MM.YYYY HH:MM format and adjust for timezone
        const [datePart, timePart] = dateString.split(' ');
        const [day, month, year] = datePart.split('.');
        const [hours, minutes] = (timePart || '0:0').split(':');
        date = new Date(year, month - 1, day, hours, minutes);
        // Adjust for timezone offset
        const offset = new Date().getTimezoneOffset();
        date = new Date(date.getTime() - offset * 60000);
    } else {
        date = new Date(dateString.replace(' ', 'T'));
    }
    
    if (isNaN(date.getTime())) return '';
    
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    const diffWeeks = Math.floor(diffDays / 7);
    const diffMonths = Math.floor(diffDays / 30);

    if (diffMins < 1) return 'Now';
    if (diffMins < 60) return `${diffMins} min ago`;
    if (diffHours < 1) return 'Now';
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffWeeks === 1) return '1 week ago';
    if (diffWeeks < 4) return `${diffWeeks} weeks ago`;
    if (diffMonths === 1) return '1 month ago';
    return `${diffMonths} months ago`;
};

const BringzzChatRow = ({ onArchive, onDelete, chat, isNew, onClick }) => {
    const [isIconsVisible, setIsIconsVisible] = useState(false);
    const { getUser } = useUser();
    const user = getUser();

    const toggleIconsVisibility = () => {
        setIsIconsVisible(!isIconsVisible);
    };

    const deleteChat = async () => {

    }

    // Determine if this is a new chat (no messages) based on lastText
    const hasMessages = chat.lastText && chat.lastText !== false && typeof chat.lastText === 'object';
    const isNewChat = !hasMessages;

    return (
        <div
            className="flex min-h-20 items-center p-4 relative overflow-hidden border-b cursor-pointer"
        >
            <div className={`flex w-full transition-transform duration-300 ${isIconsVisible && !isNewChat ? 'translate-x-[-130px]' : ''}`}>
                <div className="w-14 h-14 flex-shrink-0 rounded-full bg-gray-200 mr-4 flex justify-center items-center text-2xl font-bold">
                    {chat.recipient?.initials || 'N/A'}
                </div>
                <div className="flex-grow flex justify-center flex-col" onClick={onClick}>
                    <BringzzText tag='h4' className="font-bold">{chat.recipient?.fullName || 'Unknown'}</BringzzText>
                    {hasMessages && (
                        <>
                            <BringzzText tag='h5' className="font-normal italic line-clamp-2">
                                {chat.lastText.text_content}
                            </BringzzText>
                            <BringzzText tag='h5' className="font-normal italic text-midnight-blue/60">{getRelativeTime(chat.lastText.created)}</BringzzText>
                        </>
                    )}
                </div>
                {!isNewChat && (
                    <div className="flex items-center text-midnight-blue/60 cursor-pointer" onClick={toggleIconsVisibility}>
                        <BringzzIcon
                            size="20"
                            icon="IconChevronRight"
                            folder="LineIcons"
                        />
                    </div>
                )}
            </div>

            {isIconsVisible && !isNewChat && (
                <div className="absolute flex right-0 top-0 h-full transition-opacity duration-300" style={{ width: '130px' }}>
                    <div className="w-1/2 h-full flex justify-center items-center bg-magic-lilac/20">
                        <BringzzIcon
                            size="22"
                            icon="IconTrashCan"
                            folder="LineIcons"
                            className="cursor-pointer"
                            onClick={() => onDelete(chat.chatId)}
                        />
                    </div>
                    <div className="w-1/2 h-full flex justify-center items-center bg-magic-lilac/60">
                        <BringzzIcon
                            size="22"
                            icon="IconArchive"
                            folder="LineIcons"
                            className="cursor-pointer"
                            onClick={(event) => onArchive(chat.chatId)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default BringzzChatRow;
